import * as React from 'react'

export const SVG_NoConnection = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="99" height="98" viewBox="0 0 99 98">
        <g fill="none" fillRule="nonzero">
            <path
                fill="#F4F7F9"
                d="M49.5 0c27.061 0 49 21.939 49 49s-21.939 49-49 49C23.08 98 1.541 77.087.536 50.914a48.895 48.895 0 0 1 0-3.828C1.541 20.913 23.08 0 49.5 0z"
            />
            <path
                fill="#323B5A"
                d="M85.322 47.39h13.14c.027.636.038 1.273.038 1.915 0 .64-.011 1.278-.038 1.914h-13.14V47.39z"
            />
            <path
                fill="#95A5B4"
                d="M54.506 56.312h12.282v3.833H54.432a1.916 1.916 0 0 1-1.913-2.034c.061-1.024.961-1.799 1.987-1.799zM54.506 38.464h12.282v3.833H54.432a1.917 1.917 0 0 1-1.913-2.034c.061-1.024.961-1.799 1.987-1.799z"
            />
            <path
                fill="#474F6F"
                d="M63.444 33.794h8.749c.12 0 .238.001.357.004 4.267.097 8.015 2.212 10.391 5.414a4.76 4.76 0 0 0 3.818 1.929h.944v16.327h-.944a4.76 4.76 0 0 0-3.818 1.93c-2.376 3.201-6.124 5.317-10.39 5.414-.12.002-.238.003-.358.003h-8.75v-31.02z"
            />
            <path
                fill="#323B5A"
                d="M63.444 33.794h8.749c.12 0 .238.001.357.004 4.267.097 8.015 2.212 10.391 5.414a4.76 4.76 0 0 0 3.818 1.929h.944v8.164h-24.26v-15.51z"
            />
            <path fill="#323B5A" d="M63.444 64.815V33.794h5.638v31.021z" />
            <path fill="#20273A" d="M63.444 49.305V33.794h5.638v15.511z" />
            <path
                fill="#323B5A"
                d="M82.941 39.212a4.76 4.76 0 0 0 3.818 1.929h.944v16.327h-.944a4.76 4.76 0 0 0-3.818 1.93V39.212z"
            />
            <path fill="#20273A" d="M82.941 39.212a4.76 4.76 0 0 0 3.818 1.929h.944v8.164h-4.762V39.212z" />
            <g>
                <path fill="#323B5A" d="M.536 47.39h13.142v3.829H.536a48.895 48.895 0 0 1 0-3.828z" />
                <path fill="#20273A" d="M.536 47.39h13.142v1.915H.5c0-.642.011-1.279.036-1.914z" />
                <path
                    fill="#474F6F"
                    d="M35.556 33.794h-8.749c-.12 0-.238.001-.357.004-4.267.097-8.015 2.212-10.391 5.414a4.76 4.76 0 0 1-3.818 1.929h-.944v16.327h.944c1.506 0 2.92.72 3.818 1.93 2.376 3.201 6.124 5.317 10.39 5.414.12.002.238.003.358.003h8.75v-31.02z"
                />
                <path
                    fill="#323B5A"
                    d="M35.556 33.794h-8.749c-.12 0-.238.001-.357.004-4.267.097-8.015 2.212-10.391 5.414a4.76 4.76 0 0 1-3.818 1.929h-.944v8.164h24.26v-15.51z"
                />
                <path fill="#323B5A" d="M29.918 64.815V33.794h5.638v31.021z" />
                <path fill="#20273A" d="M29.918 49.305V33.794h5.638v15.511z" />
                <path
                    fill="#323B5A"
                    d="M16.059 39.212a4.76 4.76 0 0 1-3.818 1.929h-.944v16.327h.944c1.506 0 2.92.72 3.818 1.93V39.212z"
                />
                <path fill="#20273A" d="M16.059 39.212a4.76 4.76 0 0 1-3.818 1.929h-.944v8.164h4.762V39.212z" />
            </g>
        </g>
    </svg>
)
